import {
  ElLoading, 
  ClickOutside as vClickOutside,
  
  ElInput, 
  // ElInputNumber, 
  ElTooltip, 
  ElPopover, 
  ElDivider, 
  ElSwitch,
  ElDatePicker,
  ElSelect,
  ElSelectV2,
  ElOption,
  ElRadio,
  ElTable,
  ElTableColumn,
  ElButton,
  ElDropdownItem,
  ElDropdownMenu,
  ElDropdown,
  // ElTabs,
  // ElTabPane,
  ElImage,
  ElUpload,
  ElCollapse,
  ElCollapseItem,
  // ElTag,
  ElRadioGroup,
  ElRadioButton,
  ElCheckbox,
  ElCheckboxGroup,
  ElConfigProvider,
  ElLink,
  ElCard,
  ElProgress,
  ElScrollbar,
} from 'element-plus';

import 'element-plus/theme-chalk/el-loading.css';
import type { App } from 'vue';

const _registredComponents = {
  ElInput,
  // ElInputNumber, 
  ElTooltip, 
  ElPopover, 
  ElDivider, 
  ElSwitch,
  ElDatePicker,
  ElSelect,
  ElSelectV2,
  ElOption,
  ElRadio,
  ElTable,
  ElTableColumn,
  ElButton,
  ElDropdownItem,
  ElDropdownMenu,
  ElDropdown,
  // ElTabs,
  // ElTabPane,
  ElImage,
  ElUpload,
  ElCollapse,
  ElCollapseItem,
  // ElTag,
  ElRadioGroup,
  ElRadioButton,
  ElCheckbox,
  ElCheckboxGroup,
  ElConfigProvider,
  ElLink,
  ElCard,
  ElProgress,
  ElScrollbar,
};

export const registredComponents = Object.keys(_registredComponents);


export function ElementSetup(app: App<Element>) {
  app.directive('click-outside', vClickOutside);
  app.directive('loading', ElLoading.directive);

  app.use(ElInput);
  // app.use(ElInputNumber);
  app.use(ElTooltip);
  app.use(ElPopover);
  app.use(ElDivider);
  app.use(ElSwitch);
  app.use(ElDatePicker);
  app.use(ElSelect);
  app.use(ElSelectV2);
  app.use(ElOption);
  app.use(ElRadio);
  app.use(ElTable);
  app.use(ElTableColumn);
  app.use(ElButton);
  app.use(ElDropdownItem);
  app.use(ElDropdownMenu);
  app.use(ElDropdown);
  // app.use(ElTabs);
  // app.use(ElTabPane);
  app.use(ElImage);
  app.use(ElUpload);
  app.use(ElCollapse);
  app.use(ElCollapseItem);
  // app.use(ElTag);
  app.use(ElRadioGroup);
  app.use(ElRadioButton);
  app.use(ElCheckbox);
  app.use(ElCheckboxGroup);
  app.use(ElLink);
  app.use(ElCard);
  app.use(ElProgress);
  app.use(ElConfigProvider);
  app.use(ElScrollbar);
}
